var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
var ItemAddRowDirective = /** @class */ (function (_super) {
    __extends(ItemAddRowDirective, _super);
    function ItemAddRowDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.err_p = _this.renderer.createElement('p');
        return _this;
    }
    ItemAddRowDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ItemAddRowDirective.prototype.onInit = function () {
    };
    ItemAddRowDirective.prototype.addRequiredError = function (errFlg, msg) {
        var element = this.el.nativeElement;
        var el = element.querySelector('.formError');
        if (errFlg) {
            if (!el) {
                this.err_text = this.renderer.createText(msg);
                this.renderer.addClass(this.err_p, 'formError');
                this.renderer.appendChild(this.err_p, this.err_text);
                this.renderer.insertBefore(element, this.err_p, element.firstChild);
            }
        }
        else {
            if (el) {
                this.renderer.removeChild(this.err_p, this.err_text);
                this.renderer.removeChild(element, this.err_p);
            }
        }
    };
    ItemAddRowDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[itemAddRowDir]'
                },] }
    ];
    /** @nocollapse */
    ItemAddRowDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    return ItemAddRowDirective;
}(ClassBaseDirective));
export { ItemAddRowDirective };
//# sourceMappingURL=item-addrow.directive.js.map